<template>
  <svg
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 11C22 17.0753 17.0753 22 11 22C4.9247 22 0 17.0753 0 11C0 4.9247 4.9247 0 11 0C17.0753 0 22 4.9247 22 11ZM14.7071 9.70711C15.0976 9.31658 15.0976 8.68342 14.7071 8.29289C14.3166 7.90237 13.6834 7.90237 13.2929 8.29289L10 11.5858L8.70711 10.2929C8.31658 9.90237 7.68342 9.90237 7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.29289 11.7071L9.29289 13.7071C9.68342 14.0976 10.3166 14.0976 10.7071 13.7071L14.7071 9.70711Z"
    />
  </svg>
</template>
